// Import styles
import '../scss/main.scss';

// Import vendor dependencies
import 'bootstrap';
import AOS from 'aos';
import 'slick-carousel';

// Initialize AOS
AOS.init({
  duration: 800,
  once: true
});

// Initialize any other plugins or custom code here
document.addEventListener('DOMContentLoaded', () => {
  // Your custom JavaScript initialization here
}); 